@if (combinedQueryLoadingState$ | async; as combinedQueryLoadingState) {
  @if (
    combinedQueryLoadingState.definitionState.isLoading ||
    combinedQueryLoadingState.reportState.isLoading ||
    combinedQueryLoadingState.reportGroupsState.isLoading
  ) {
    <div class="center">
      <gc-loading-spinner />
    </div>
  } @else {
    @if (checkQueryParamValidity()) {
      @if (
        combinedQueryLoadingState.definitionState.data &&
        combinedQueryLoadingState.reportGroupsState.data
      ) {
        <div class="report">
          <app-report-info-v2
            [distributionPointProperties]="distributionPointProperties"
          />
          <app-report-groups [typeId]="typeId" />
        </div>
      }

      @if (showImagePreview$ | async) {
        <app-image-preview-v2
          [images]="(imagePreviewAttachments$ | async) ?? []"
          [isLoading$]="isLoadingImagePreview$"
          (closeModal)="closeImagePreview()"
          (downloadFiles)="downloadImages($event)"
          (uploadFiles)="uploadImage($event)"
          (deleteFile)="deleteImage($event)"
        />
      }
    } @else {
      <div class="center">
        <app-error-information
          [iconName]="'smileySad'"
          [iconColor]="'caution'"
          [errorString]="'reportInput.errorReport' | translate"
        />
      </div>
    }
  }
}

<app-feedback-alert />
